import React from 'react';
import { Form, FormikContext, useFormik } from 'formik';

import { validationSchema } from 'endpoints/auth/client-via-auth-token';
import { signInWithToken } from 'client/redux/client/actions';
import { useAppDispatch, useAppSelector, useTranslation } from 'client/hooks';
import { selectRoomId } from 'client/redux/room/selectors';
import { setShouldInitPubnub } from 'client/redux/ui';

import Input from '../LogIn/Input';
import Button from '../Button';

import css from './LoginWithAuthTokenPopUp.module.scss';
import { selectUserAuth } from 'client/redux/client/selectors';

type Props = {
  token: string;
};
validationSchema;

const LoginWithAuthTokenPopUp: React.FC<Props> = (props) => {
  const { token } = props;
  const dispatch = useAppDispatch();
  const { translate } = useTranslation('popUps');
  const auth = useAppSelector(selectUserAuth);
  const roomId = useAppSelector(selectRoomId);
  const formikContext = useFormik({
    initialValues: { password: '', token, roomId },
    onSubmit: async (values) => {
      await dispatch(
        signInWithToken({
          ...values,
        }),
      );

      dispatch(setShouldInitPubnub(true));
    },
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
  });
  const buttonLabel = translate('loginWithAuthTokenPopUp.submitBtnLabel');

  return (
    <div className={css.loginWithToken}>
      <div className={css.content}>
        <FormikContext.Provider value={formikContext}>
          <Form>
            <Input
              className={css.input}
              inputClassName={css.inputIn}
              name="password"
              label={translate('loginWithAuthTokenPopUp.passwordLabel')}
              placeholder={translate('loginWithAuthTokenPopUp.passwordPlaceholder')}
              type="password"
            />
            <Button className={css.submitBtn} label={buttonLabel} disabled={auth.isInProgress} type="submit" />
          </Form>
        </FormikContext.Provider>
      </div>
    </div>
  );
};

export default LoginWithAuthTokenPopUp;
